import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "m45.18 4.962 1.896 1.317-2.756 3.966c2.449-.304 5.127-.427 7.691.867a10.6 10.6 0 0 1 5.638 11.422l-.214 1.134-2.268-.428.214-1.134a8.29 8.29 0 0 0-4.41-8.933c-1.861-.94-3.802-.925-5.981-.678l3.663 2.545-1.317 1.896-7.064-4.91zM.999 6.535a4.25 4.25 0 0 1 4.249-4.248h26.751a4.25 4.25 0 0 1 4.25 4.248v51.93a4.25 4.25 0 0 1-4.25 4.249H5.248a4.25 4.25 0 0 1-4.249-4.25zM5.248 4.49c-1.13 0-2.046.916-2.046 2.045v51.93c0 1.13.916 2.045 2.046 2.045h26.751c1.13 0 2.046-.915 2.046-2.045V6.535c0-1.13-.916-2.045-2.046-2.045zm53.503 24.549A4.25 4.25 0 0 1 63 33.287v25.178a4.25 4.25 0 0 1-4.249 4.249H39.868v-2.203H58.75c1.13 0 2.046-.916 2.046-2.046V33.287c0-1.13-.916-2.045-2.046-2.045H39.868v-2.203z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }